import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { CookiesProvider } from 'react-cookie';
import ApolloClient from 'apollo-boost';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import theme from './theme';
import '../i18n';
import '../index.css';

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPH_QL_URL,
});

const ProviderWrapper = ({ children, store, history }) => (
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <CookiesProvider>
                <ConnectedRouter history={history}>
                    <SnackbarProvider
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        maxSnack={3}
                    >
                        <CssBaseline />
                        {children}
                    </SnackbarProvider>
                </ConnectedRouter>
            </CookiesProvider>
        </ThemeProvider>
    </Provider>
);

export default ProviderWrapper;
